import React from 'react';
import { Link } from 'react-router';

import './header.css';

const Header = ({ hideLinks }) => (
  <div className="o-header">
    {!hideLinks && (
      <Link
        to="/"
        tabIndex={2}
        className="a-search-exit u-scale-on-hover u-smooth-transitions">
        <i className="fa fa-home"></i>
      </Link>
    )}
  </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js